"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var yup = _interopRequireWildcard(require("yup"));

var schema = yup.array().of(yup.string().typeError('actionsArray should be an array of strings')).typeError('actionsArray should be an array');
/**
 * Receives an array of strings, and returns an obj with that strings as properties
   with that string as value.
 * E.G:
 * stringArrayToObject(['A', 'B', 'C']) // { A: 'A', B: 'B', C: 'C' }
 */

function stringArrayToObject(actionsArray, namespace) {
  schema.validateSync(actionsArray);
  var actionNames = {};
  actionsArray.forEach(function (actionName) {
    actionNames[actionName] = namespace ? "".concat(namespace, "/").concat(actionName) : actionName;
  });
  return actionNames;
}

function createTypes(actionsArray, namespace) {
  if (!namespace) console.warn('No namespace provided while creating action types');
  return stringArrayToObject(actionsArray, namespace);
}

var _default = createTypes;
exports["default"] = _default;